// Camel (M19-adjacent). PURE (ENG-1). A tall two-seat desert mount: it dashes
// forward on a cooldown and can sit or stand. These are the pure rules the host
// applies; the ride/steer plumbing rides the shared mount system (mount.ts).
import { CAMEL } from '../config';

/** Passenger seats a camel carries. */
export function camelSeats(): number {
  return CAMEL.SEATS;
}

/** A camel may dash only once its dash cooldown has elapsed. */
export function camelCanDash(cooldown: number): boolean {
  return cooldown <= 0;
}

/** Horizontal impulse of a camel's dash. */
export function camelDashImpulse(): number {
  return CAMEL.DASH_IMPULSE;
}

/** Upward hop added to a dash. */
export function camelDashHop(): number {
  return CAMEL.DASH_HOP;
}

/** Ticks before a camel may dash again. */
export function camelDashCooldown(): number {
  return CAMEL.DASH_COOLDOWN;
}

/** Toggle a camel between sitting and standing. */
export function camelSitStand(sitting: boolean): boolean {
  return !sitting;
}
